export enum PASSWORD_TYPES {
    First = "first",
    Repeat = "repeat"
}
